(() => {
    console.log('%c👍🏼 Hero Slide In', 'color: yellow');
    const section = document.querySelector('.hero-slide-in-section');
    const heroVideo = section.querySelector('video');
    const slideInSection = section.querySelector('.hero-slide-in-section__slide-in-section');
    const sentinal = section.querySelector('.hero-slide-in-section__sentinal-50');
    const cta = section.querySelector('.hero-slide-in-section__slide-in-section button');
    let minScale = 0.1;
    const infoSections = slideInSection.querySelectorAll('[data-slide-in-from]');
    const minScaleIn = Number(heroVideo.dataset.minScale);
    const aiSearch = document.querySelector('#root');

    const calculateMinScale = () => {
        if (window.innerWidth < 768) {
            minScale = 0.3;
        } else {
            minScale = 0.1;
        }
    }

    calculateMinScale();

    window.addEventListener('resize', calculateMinScale);

    const scrollHandler = () => {
        // Calculate the scale factor based on the scroll position
        const scale = Math.max(minScale, (window.innerHeight - window.scrollY) / this.window.innerHeight);

        // Apply the scale transformation to the element
        heroVideo.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';

        if (window.scrollY > 10) {
            heroVideo.style.opacity = 1;

            if (scale === minScale) {
                heroVideo.classList.remove('object-cover');

                // if (window.innerWidth < 768) {
                //     heroVideo.classList.add('object-contain', 'object-top');
                // } else {
                    heroVideo.classList.add('object-contain');
                //}
            }
        } else {
            heroVideo.style.opacity = 1;
            heroVideo.classList.remove('object-contain', 'object-top');
            heroVideo.classList.add('object-cover');
        }

        const scrollPercentage = (window.innerHeight - window.scrollY) / this.window.innerHeight;

        let initPosition = true;
        if(initPosition) {
            heroVideo.classList.add('video-masked');
            heroVideo.style.maskSize = `100%`;
            initPosition = false
        }
        if(scrollPercentage == 1) {
            heroVideo.classList.remove('video-masked');
            heroVideo.style.maskSize = `6000%`;
            initPosition = true;
        } 
    };

    const scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                window.addEventListener('scroll', scrollHandler);
            } else {
                window.removeEventListener('scroll', scrollHandler);
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0
    });

    scrollObserver.observe(section);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                infoSections.forEach((infoSection) => {
                    const direction = infoSection.dataset.slideInFrom;
                    if (direction === 'left') {
                        infoSection.classList.remove('opacity-0', '-translate-x-[50vw]');
                    } else if (direction === 'right') {
                        infoSection.classList.remove('opacity-0', 'translate-x-[50vw]');
                    }
                });

                if(cta) {
                    cta.classList.remove('opacity-0');
                }
            } else {
                infoSections.forEach((infoSection) => {
                    const direction = infoSection.dataset.slideInFrom;
                    if (direction === 'left') {
                        infoSection.classList.add('opacity-0', '-translate-x-[50vw]');
                    } else if (direction === 'right') {
                        infoSection.classList.add('opacity-0', 'translate-x-[50vw]');
                    }
                });

                if(cta) {
                    cta.classList.add('opacity-0');
                }
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0.5 // trigger when 30% of the section is in view
    });

    observer.observe(sentinal);

    const observer2 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                heroVideo.classList.add('hidden');
                if(aiSearch) {
                    aiSearch.classList.remove('hidden');
                }
                slideInSection.classList.add('hidden');
                heroVideo.pause();
            } else {
                if(aiSearch) {
                    aiSearch.classList.add('hidden');
                }
                heroVideo.classList.remove('hidden');
                slideInSection.classList.remove('hidden');
                heroVideo.play();
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0 // trigger when 30% of the section is in view
    });

    observer2.observe(section);

    const setupAudioToggle = () => {
        const audioToggle = section.querySelector('.hero-slide-in-section__audio-toggle');
        const muteIcon = audioToggle.querySelector('[data-audio-toggle="mute"]');
        const unmuteIcon = audioToggle.querySelector('[data-audio-toggle="unmute"]');

        const toggleAudio = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // if video sound is on, turn it off
            if (!heroVideo.muted) {
                heroVideo.muted = true;
                muteIcon.classList.add('hidden');
                unmuteIcon.classList.remove('hidden');
            } else {
                heroVideo.muted = false;
                muteIcon.classList.remove('hidden');
                unmuteIcon.classList.add('hidden');

                if (!audioToggle.dataset.clicked) {
                    audioToggle.dataset.clicked = 'true';

                    // restart video
                    heroVideo.currentTime = 0;
                    heroVideo.play();
                }
            }
        };

        // Add click event listener
        audioToggle.addEventListener('click', toggleAudio);
    };

    setupAudioToggle();

    const addScrollToEvent = () => {
        const discoverMore = section.querySelector('.hero-slide-in-section__discover button');
        if (!discoverMore) {
            return;
        }

        discoverMore.addEventListener('click', () => {
            window.scrollTo({
                top: window.innerHeight,
                left: 0,
                behavior: "smooth",
            });
        });
    };

    addScrollToEvent();
})();